import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-sm max-w-[338px]" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex gap-2 items-center w-full font-medium leading-none whitespace-nowrap text-zinc-800" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "mt-3 p-2 bg-red-100 text-red-700 rounded-md text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResourceSection = _resolveComponent("ResourceSection")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.overviewIcon,
          class: "object-contain shrink-0 self-stretch my-auto w-6 aspect-square",
          alt: "Overview icon"
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "self-stretch my-auto" }, "Overview", -1))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mt-3 leading-5 text-gray-500" }, " Here are pre-created resources that you can share internally and use for enablement and training. ", -1))
    ]),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_ResourceSection, {
      title: "Download Program Overview",
      onCardClick: _ctx.handleCardClick,
      onDownloadClick: _ctx.handleDownloadClick
    }, null, 8, ["onCardClick", "onDownloadClick"])
  ]))
}